import React from 'react';
import MuiDialog from '@material-ui/core/Dialog';
import useScreenSize from 'hooks/use-screen-size';

export default function Dialog(params) {
  const screenSize = useScreenSize();
  const isMobile = screenSize === 'xs';
  return <MuiDialog fullScreen={isMobile} {...params} />;
}
